import _ from "lodash";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import SoftTypography from "components/SoftTypography";
import { useEffect, useState } from "react";
import ApiService from "services/ApiService";
import ToastUtils from "utils/ToastUtils";

function CompaniesSelect({ xs = 12, md = 4, handler, initValue, error = false }) {
  const [companies, setCompanies] = useState([]);
  const [value, setValue] = useState(null);

  const handleChange = (e) => {
    setValue(e);
    handler(e.id);
  };

  const fetchCompanies = async () => {
    const response = await ApiService.getData(`/api/v1/companies`);

    if (!response) {
      ToastUtils.error("Αδυναμία εύρεσης εταιρειών!");
      return;
    }
    const companies = response.data.data;
    companies.map((el) => {
      el.value = el.id;
      el.label = `${el.vatNumber} - ${el.friendlyName}`;
    });
    setCompanies(companies);
    if (initValue) {
      const company = companies.find((el) => el.id === Number(initValue));
      if (!company) return;
      setValue(company);
      handler(company.id);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return (
    <Grid item xs={xs} md={md}>
      <SoftBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
        <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
          <SoftTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Επιλογή εταιρείας
          </SoftTypography>
        </SoftBox>
        <SoftSelect
          placeholder="Επιλογή Εταιρείας"
          options={companies}
          size="large"
          onChange={handleChange}
          value={value}
          error={error}
        />
      </SoftBox>
    </Grid>
  );
}

export default CompaniesSelect;
